import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const orderApi = createApi({
    reducerPath:'orderApi',
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API_URL,
        credentials: 'include',
        prepareHeaders: (headers) => {
          const token = localStorage.getItem('_at') || null; // Check for token    
          if (token) {
            headers.set("Authorization", "Bearer " + token); // If logged in, add token to headers
          }    
          return headers;
        },
      }),
      tagTypes:['Order'],
      endpoints:(builder)=>({
        listOrderForAdmin:builder.query({
            query:({ page = 1, limit = 10, search = '' }) => {
                const cleanSearch = search.trim();
                return `/order?page=${page}&limit=${limit}&search=${encodeURIComponent(cleanSearch)}`;
            },
            method:"GET",
            providesTags:['Order'],
        }),
        listOrderForUser:builder.query({
            query:({ page = 1, limit = 10, search = '' })=> `/order/listForUser?page=${page}&limit=${limit}&search=${search}`,
            method:'GET',
            providesTags:['Order'],
            
        }),
        listOrderDetailByIdForAdmin:builder.query({
            query:(id)=> `/order/${id}`,
            method:"GET"
        }),
        createOrder:builder.mutation({
            query:(args)=>({
                url:'/order',
                method:"POST",
                body:args,
                headers: {
                    "Content-Type":"application/json"
                }
            }),
            invalidatesTags:['Order']
        }),
        manualCreateOrder:builder.mutation({
            query:(args)=>({
                url:'/order/manual-create',
                method:"POST",
                body:args,
                headers: {
                    "Content-Type":"application/json"
                }
            }),
            invalidatesTags:['Order']
        }),
        updateOrderForUser:builder.mutation({
            query:(orderId)=>({
                url:`/order/${orderId}/cancel`,
                method:"PUT",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }),
            invalidatesTags:['Order']
        }),
        updateOrderForAdmin:builder.mutation({
            query:({orderId,payload})=>({
                url:`/order/${orderId}`,
                body:payload,
                method:"PUT",
                headers: {
                    "Content-Type": "application/json", // Use JSON for simplicity
                },
            }),
            invalidatesTags:['Order']
        }),
        bulkInvoiceOrder:builder.mutation({
            query:(orderIds)=>({
                url:'/order/bulk-invoice',
                method:"POST",
                body:{orderIds},
                responseHandler: (response) => response.blob(),
            })
        })
    })
})

export const {useListOrderForAdminQuery,useManualCreateOrderMutation, useListOrderForUserQuery, useCreateOrderMutation, useUpdateOrderForAdminMutation, useUpdateOrderForUserMutation, useListOrderDetailByIdForAdminQuery, useBulkInvoiceOrderMutation} = orderApi